// AUTO-GENERATED by generate-zod-schemas.ts — DO NOT EDIT
// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { z } from 'zod'

export const schemaSchema = z.object({
  id: z.string().max(100),
  orgId: z.string().max(100),
  workspaceId: z.string().max(100).optional(),
  userId: z.string().max(100).optional(),
  createdAt: z.string().max(200).datetime(),
  updatedAt: z.string().max(200).datetime(),
  metadata: z.record(z.string(), z.unknown()).optional(),
  extended: z.record(z.string(), z.unknown()).optional(),
  name: z.string().max(500),
  title: z.string().max(500),
  description: z.string().max(100000),
  icon: z.string().max(50).optional(),
  category: z.string().max(200),
  target: z.string().max(20),
  fields: z.array(z.record(z.string(), z.unknown())),
  titleField: z.string().max(200),
  defaultSort: z.record(z.string(), z.unknown()).optional(),
  ownerPluginId: z.string().max(100).optional(),
  builtIn: z.boolean(),
  version: z.number().int().min(0).max(9999),
  archived: z.boolean(),
  classLevelPermissions: z.record(z.string(), z.unknown()).optional(),
  encryptedFields: z.array(z.record(z.string(), z.unknown())).optional(),
  tenantId: z.string().max(100).optional(),
})

export type SchemaInput = z.infer<typeof schemaSchema>
